import { useState } from 'react';
import type { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';

type AccordionProps = {
    accordionExpanded: boolean;
    setAccordionExpanded: ReactSetState<boolean>
}

const [useAccordionContext, Provider] = createContext<AccordionProps>('AccordionCtx');

const useInitAccordionContext = () => {
    const [accordionExpanded, setAccordionExpanded] = useState<boolean>(true)

    const accordionProps: AccordionProps = {
        accordionExpanded,
        setAccordionExpanded
    };
    return accordionProps;
};

const AccordionContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitAccordionContext()}>
        {children}
    </Provider>;
};

export { useAccordionContext, AccordionContextProvider };